/**
 * @file method.service.ts
 * @description Сервис для вызова системных методов Task Manager. Обеспечивает выполнение специализированных методов системы, включая расчет плановых дат выполнения, валидацию данных и другие служебные операции.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js', 'axios']
 * @related-files ['C:\laragon\www\task-manager\src\api\actions.js', 'C:\laragon\www\task-manager\src\types\index.ts']
 */

import { TApiData } from '@src/types';
import { postRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const MethodService = {
    /**
     * Получает плановую дату выполнения для задачи или проекта
     * @param {TApiData} body - Параметры для расчета плановой даты выполнения
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с рассчитанной плановой датой или ошибкой
     */
    getPlannedExecutionDate: async (body?: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest('method/getPlannedExecutionDate', body, undefined);
    }
};
